import { render, staticRenderFns } from "./methodology-radio-group.vue?vue&type=template&id=08ea7283"
import script from "./methodology-radio-group.ts?vue&type=script&lang=ts&external"
export * from "./methodology-radio-group.ts?vue&type=script&lang=ts&external"
import style0 from "./methodology-radio-group.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports